import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles(() => ({
  listGroup: {
    display: 'inline',
    width: '100%',
    columnGap: '4px',
    flexWrap: 'wrap',
    backgroundColor: 'transparent'
  }
}));
